import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';

import { SuggestTitleIcon } from '../../../../icons/prompt/suggestTitle';
import {
	createInsertAtCurrentPosition,
	createInsertAtTop,
	createReplaceExistingConfluenceTitle,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

export const suggestTitle: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
	title: aiConfigItemMessages.suggestTitleTitle,
	description: aiConfigItemMessages.suggestTitleDescription,
	icon: () => <SuggestTitleIcon />,
	intentSchemaId: 'suggest_title_intent_schema.json',
	actions: {
		empty: [
			createInsertAtCurrentPosition({ appearance: 'secondary' }),
			createInsertAtTop({ appearance: 'primary' }),
		],
		selection: [
			createInsertAtCurrentPosition({ appearance: 'secondary' }),
			createInsertAtTop({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
};

export const suggestTitleWithOptions: EditorPluginAIConfigItemWithOptions = {
	config: suggestTitle,
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
};

/**
 * EXPERIMENTAL: Util for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 */
export const suggestTitleForConfluenceTitleToolbar: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
	title: aiConfigItemMessages.suggestTitleTitle,
	description: aiConfigItemMessages.suggestTitleDescription,
	icon: () => <SuggestTitleIcon />,
	intentSchemaId: 'suggest_title_intent_schema.json',
	actions: {
		empty: [createReplaceExistingConfluenceTitle({ appearance: 'primary' })],
		selection: [createReplaceExistingConfluenceTitle({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
};

export const suggestTitleForConfluenceTitleToolbarWithOptions: EditorPluginAIConfigItemWithOptions =
	{
		config: suggestTitleForConfluenceTitleToolbar,
		triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
	};
